editWhatsappMessageWithButtonsController.$inject = ['$scope',
    '$mdDialog',
    '$translate',
    'elementData',
    'elementView',
    'MediasFactory',
    'AlertingFactory',
    'context'];

export function editWhatsappMessageWithButtonsController($scope,
                                                         $mdDialog,
                                                         $translate,
                                                         elementData,
                                                         elementView,
                                                         MediasFactory,
                                                         AlertingFactory,
                                                         context) {

    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.removeMedia = removeMedia;
    $scope.onHeaderTypeChange = onHeaderTypeChange;
    $scope.updateHeader = updateHeader;
    init();

    function init() {

        if (!elementData.header) {
          elementData.header = {};
        }

        $scope.site = context.site;
        $scope.companyId = context.companyId;
        $scope.mediaUrl = null;

        $scope.elementData = elementData;
        $scope.elementView = elementView;
    
        if (elementData.body) {
            $scope.initialWhatsappMessageWithButtonsModel = elementData.body;
        }
        $scope.whatsappMessageWithButtonsModelAccessor = {};
        $scope.whatsappMessageWithButtonsTextIsEmpty = false;
        
        initHeaderTypeDropdownItems();

        $scope.fileNames = {};

        $scope.$watch('fileNames.picture', (newFile) => {
          if (newFile) {
            uploadMedia(newFile, 'image');
          }
        });
        $scope.$watch('fileNames.video', (newFile) => {
          if (newFile) {
            uploadMedia(newFile, 'video');
          }
        });
        $scope.$watch('fileNames.file', (newFile) => {
          if (newFile) {
            uploadMedia(newFile, 'file');
          }
        });
        updateMediaUrls();

    }

    function initHeaderTypeDropdownItems() {
        $scope.headerTypeDropdownItems = [{
            id: 'none', 
            label: $translate.instant(elementView.resolveTranslationKey('edit_box_header_type_none'))
          },{
            id: 'text', 
            label: $translate.instant(elementView.resolveTranslationKey('edit_box_header_type_text'))
          },{
            id: 'image', 
            label: $translate.instant(elementView.resolveTranslationKey('edit_box_header_type_image'))
          },{
            id: 'video', 
            label: $translate.instant(elementView.resolveTranslationKey('edit_box_header_type_video'))
          },{
           id: 'file', 
           label: $translate.instant(elementView.resolveTranslationKey('edit_box_header_type_file'))
        }];
    }

    function ok() {
      if (validateMandatoryHiddenInputs()) {
        let whatsappMessageWithButtonsModel = $scope.whatsappMessageWithButtonsModelAccessor.getModelOfFirstMessage();
        elementData.body = whatsappMessageWithButtonsModel;
        $mdDialog.hide({ type: 'ok', data: elementData });
      }
    }
    
    function validateMandatoryHiddenInputs() {
      if (elementData.header.type == 'image' && !elementData.header.pictureId ||
          elementData.header.type == 'video' && !elementData.header.videoId ||
          elementData.header.type == 'file' && !elementData.header.fileId) {
          
            AlertingFactory.error('parameters/quick_replies/details/graph/whatsapp_message_with_buttons/missing_'.concat(elementData.header.type));
          return false;
      } else {
        return true;
      }
      
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function removeMedia() {
        updateHeader(null, null, null, null, null);
    }

    function onHeaderTypeChange() {
      updateHeader(null, null, null, null, null);
    }

    function updateHeader(pictureId, videoId, fileId, fileName, text) {
      if (elementData.header.type === "none") {
        if (!elementData.header) {
          elementData.header = {};
        }
      } else {
        elementData.header.pictureId = pictureId;
        elementData.header.videoId = videoId;
        elementData.header.fileId = fileId;
        elementData.header.fileName = fileName;
        elementData.header.text = text;
        updateMediaUrls();
      }
  }

    function uploadMedia(newFile, mediaType) {
      $scope.loading = true;
      $scope.fileName = '';
      MediasFactory.upload2($scope.companyId, $scope.site.id, mediaType, newFile, function(response) {
        $scope.loading = false;
        let pictureId = null;
        let videoId = null;
        let fileId = null;
        let fileName = null;
        if (mediaType === 'image') {
          pictureId = response.data.media_id;
        }
        if (mediaType === 'video') {
          videoId = response.data.media_id;
        }
        if (mediaType === 'file') {
          fileId = response.data.file_id;
          fileName = newFile.name;
        }
        updateHeader(pictureId, videoId, fileId, fileName, null);

      }, function(response) {
        $scope.loading = false;
        AlertingFactory.error(response.data.error);
      }, percent => {});
    }

    function updateMediaUrls() {
      $scope.mediaUrl = null;
      if (elementData.header.type == 'image' && elementData.header.pictureId) {
          $scope.mediaUrl = MediasFactory.pictureUrl($scope.companyId, elementData.header.pictureId);
      }
      if (elementData.header.type == 'video' && elementData.header.videoId) {
        $scope.mediaUrl = MediasFactory.videoUrl($scope.companyId, elementData.header.videoId);
      }
    }

}